import React from 'react';
import {WhiteSection} from './styles';

export default ({
  dataCy,
  children,
  margin = '40px',
  padding = '20px',
}: {
  margin?: string;
  dataCy?: string;
  padding?: string;
  children: React.ReactNode;
}) => (
  <>
    <WhiteSection data-cy={dataCy} padding={padding}>
      {children}
    </WhiteSection>
    {margin && <div style={{margin, display: 'flex'}}></div>}
  </>
);
